import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('novurem_cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('novurem_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('novurem_cookie_consent', 'declined');
    setVisible(false);
  };

  const handleConfig = () => {
    localStorage.setItem('novurem_cookie_consent', 'configured');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-inner">
        <p>
          Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu bieten.
          Cookies helfen uns, die Nutzung der Website zu analysieren und Ihre Erfahrung zu verbessern.
          Weitere Informationen finden Sie in unserer <Link to="/privacy-policy" style={{ color: '#f7d9a8' }}>Datenschutzerklärung</Link>.
        </p>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn">Alle akzeptieren</button>
          <button onClick={handleDecline} className="cookie-btn cookie-btn-outline">Ablehnen</button>
        </div>
      </div>
    </div>
  );
}